import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import { URLSearchParams } from 'url';
import { DestinationModel, IDestinationCreateForm, IDestinationEditForm } from '../models/destination.model';
import { CampaignCreativeModel } from '../models/campaign-creative.model';
import { CreativeModel } from '../models/creative.model';
import endpoints from './endpoints/index.endpoints';

export const DestinationsApi = {
	list: async (params?: URLSearchParams): Promise<DestinationModel[]> => {
		return ask.get(endpoints.destinations.list(), params);
	},

	get: async (destinationId: id, params?: URLSearchParams, options?: IRequestOptions): Promise<DestinationModel> => {
		return ask.get(endpoints.destinations.get(destinationId), params, options);
	},

	create: async (body: IDestinationCreateForm, options?: IRequestOptions): Promise<DestinationModel> => {
		return ask.post<IDestinationCreateForm>(endpoints.destinations.create(), body, options);
	},

	edit: async (destinationId: id, body: IDestinationEditForm, options?: IRequestOptions): Promise<DestinationModel> => {
		return ask.patch<IDestinationEditForm>(endpoints.destinations.edit(destinationId), body, options);
	},

	delete: async () => {
		throw new Error('Not implemented');
	},

	listCreatives: (destinationId: id, options?: URLSearchParams): Promise<CampaignCreativeModel[]> => {
		return ask
			.get(endpoints.destinations.listCreatives(destinationId), options)
			.then((response: CampaignCreativeModel[] | CreativeModel[]) => {
				if (!Array.isArray(response)) {
					return [];
				}
				if (response.length > 0 && 'creative' in response[0]) {
					return (response as CampaignCreativeModel[]).map(item => new CampaignCreativeModel(item));
				}
				return (response as CreativeModel[]).map(creative => new CampaignCreativeModel({ creative: new CreativeModel(creative) }));
			});
	},

	addCreative: (destinationId: id, creativeId: id, options?: IRequestOptions): Promise<null> => {
		return ask.post(endpoints.destinations.addCreative(destinationId), [creativeId], options);
	},

	removeCreative: (destinationId: id, creativeId: id, options?: IRequestOptions): Promise<null> => {
		return ask.delete(endpoints.destinations.removeCreative(destinationId, creativeId), options);
	},
};
